import React from 'react';
import './hr.css';

const Hr = () => {
  return (
    <div className='hr'>
        <hr/>
        <hr/>
    </div>
  )
}

export default Hr